import { VideoAspectRatioTypes } from '@picsart/rc/types';

// MEDIA Properties

export interface GlobalMediaProps extends IStrapiComponent {
  src: string;
  ratio?: VideoAspectRatioTypes;
}

export interface ImageProps extends GlobalMediaProps {
  alt?: string;
}

export interface VideoProps extends GlobalMediaProps {
  poster?: string;
}

// TEMPLATES

export type FetchedTemplateModel = {
  id: string;
  _id?: string;
  url: string;
  license?: string;
  is_paid?: boolean;
  type?: string;
  commercial?: boolean;
  width?: number;
  height?: number;
  item_width?: number;
  item_height?: number;
};

export type TemplateItemProps = IStrapiComponent & {
  template: FetchedTemplateModel;
  tag?: string;
  ariaLabel?: string;
};

export type GenericTemplateProps = TemplateItemProps & {
  styles?: any;
  isNewTemplates?: boolean;
};

export interface IStrapiComponent {
  cmsName?: string;
  cmsId?: number | string;
  index?: number;
}

export enum ButtonTypes {
  a = 'Link',
  label = 'Upload',
  button = 'Button',
}

export const EDITOR_QUERY_NAME = {
  template: 'template',
  image: 'imageId',
};

export enum SOCIAL_MEDIA_TYPE_ENUM {
  FACEBOOK,
  PINTEREST,
  TWITTER,
  LINKEDIN,
  TUMBLR,
}
